import template from './cannotSignupModal.html';
import controller from './cannotSignupModal.controller';
import './cannotSignupModal.scss';

let cannotSignupModalComponent = {
  restrict: 'E',
  bindings: {
    cannotSignUpError: '<',
    onDismiss: '&',
    isMobileApp: '<',
    loanModality:'<'
  },
  template,
  controller,
};

export default cannotSignupModalComponent;



// WEBPACK FOOTER //
// ./client/app/components/cannotSignupModal/cannotSignupModal.component.js